import { jsx as x } from "react/jsx-runtime";
import f from "react";
import { cn as s } from "../../utils/cn.js";
const u = {
  sm: "gst-text-xs leading-normal",
  base: "gst-text-sm leading-normal",
  lg: "gst-text-base leading-normal",
  xl: "gst-text-lg leading-normal"
}, p = {
  left: "gst-text-left",
  center: "gst-text-center",
  right: "gst-text-right"
}, b = {
  default: "gst-text-default",
  muted: "gst-text-muted",
  error: "gst-text-error",
  success: "gst-text-success",
  warning: "gst-text-warning"
}, N = f.forwardRef(
  (a, n) => {
    const {
      size: r = "base",
      className: l,
      children: g,
      bold: i,
      type: t,
      align: e,
      ellipsis: o,
      underline: m,
      ...c
    } = a, d = s(
      "gst-m-0",
      // Foundation reset
      u[r],
      l
    );
    return /* @__PURE__ */ x(
      "p",
      {
        ref: n,
        className: s(
          d,
          e && p[e],
          i && "gst-font-semibold",
          t && b[t],
          m && "gst-underline",
          o && "gst-truncate"
        ),
        ...c,
        children: g
      }
    );
  }
);
N.displayName = "Text";
export {
  N as default
};
